<template>
    <button class="flat-icon-button">
        <span>
            <i :class="icon"></i>
        </span>
        <span> {{ label }} </span>
    </button>
</template>

<script>
export default {
    name: "flat-icon-button",
    props: [
        "id",
        "label",
        "icon"
    ]
}
</script>

<style>

.flat-icon-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
}

.flat-icon-button span:first-of-type {
    display: inline-block;
    margin-right: 5px;
}

.flat-icon-button i {
    font-size: 24px;
}

.flat-icon-button:hover {
    opacity: .66;
}

.flat-icon-button:active {
    opacity: .33;
}

</style>